import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { ALLOWED_MODULES } from "../../../constants/enums";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";

const VoiceCallCampaignsTable = Loadable(
  lazy(() =>
    import("./VoiceCallCampaignsTable").then(({ VoiceCallCampaignsTable }) => ({
      default: VoiceCallCampaignsTable,
    }))
  )
);

export const voiceCampaignsRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.campaigns.voice.campaigns,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <VoiceCallCampaignsTable />
      </AuthorizedRoute>
    ),
  },
];
